// @generated by TypeGen from LogbookModel/Device.swift - DO NOT EDIT

export interface IDeviceInformation {
  deviceId: string;
  hostname: string;
  logbookVersion: string;
  osName: IDeviceOS;
  osVersion: string;
}

export enum IDeviceOS {
  macOS = "macOS",
  windows = "windows",
  iOS = "iOS",
  iPadOS = "iPadOS",
  androidTablet = "androidTablet",
  androidPhone = "androidPhone",
  linux = "linux",
  logbookBox = "logbookBox",
  unknown = "unknown",
}

export enum IDeviceType {
  primary = 0,
  pc = 1,
  tablet = 2,
  mobile = 3,
}
